import { DownloadIcon } from '@chakra-ui/icons';
import { Heading } from '@chakra-ui/react';
import { Loading } from '../Common/Loading';
import { useTranslation } from 'react-i18next';

const HistorialPagos = ({ user, coTitular = null, isLoading = false }) => {

  const { t } = useTranslation();

  if (isLoading) return <Loading />;

  // combine payments from user and co-titular
  const combinedPagos = [...(user?.pagos || []), ...(coTitular?.pagos || [])];

  if (!combinedPagos.length)
    return (
      <Heading
        size="md"
        my="5"
      >
        {t('PAYMENT_HISTORY_EMPTY')}
      </Heading>
    );

  return (
    <div className="py-2">
      <Heading
        size="lg"
        my="5"
      >
        {t('PAYMENT_HISTORY_TITLE')}
      </Heading>
      <table className="table table-striped">
        <thead>
          <tr>
            <th className="col-sm px-sm-2">{t('PAYMENT_AMOUNT')}</th>
            <th className="col-sm px-sm-2">{t('PAYMENT_DATE')}</th>
            <th className="col-sm px-sm-2">{t('PAYMENT_RECEIPT')}</th>
          </tr>
        </thead>
        <tbody>
          {combinedPagos.map((pago) => (
            <tr key={pago.id}>
              <td className="col-sm px-sm-2">
                {pago.monto ? `$${pago.monto}` : '-'}
              </td>
              <td className="col-sm px-sm-2">
                {pago.fecha ? pago.fecha.split('T')[0] : '-'}
              </td>
              <td
                className="col-sm px-sm-2"
                style={{ cursor: 'pointer' }}
              >
                <a
                  href={`${process.env.REACT_APP_STORAGE_URL}/${user.id}/comprobantes/${pago.id}`}
                  download={`comprobante-${pago.fecha.split('T')[0]}`}
                  target="_self"
                >
                  <DownloadIcon />
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HistorialPagos;
